.root {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin: 0;
    padding: 0;
}
.item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}
.item > :global(svg) {
    min-height: 20px;
    min-width: 20px;
}
.root[data-color="success"] {
    .item[data-checked="true"] {
        color: var(--sentiment-text-positive);
    }
}
.root[data-color="primary"] {
    .item[data-checked="true"] {
        color: var(--primary-enabled);
    }
}